import { Button, Card } from '@zenid/web';
import { useCallback, useMemo, useState } from 'react';
import { css } from '../../../../styled-system/css';
import { flex } from '../../../../styled-system/patterns';
import { INTEGRATION_IRREVERSIBLE_MESSAGE, IntegrationConsent } from './IntegrationConsent';

type Props = {
  proceed: () => Promise<void>;
};

/**
 * 学籍番号が一致する ZEN大学特別聴講生アカウントが存在する場合に、サブメールアドレス追加フォームの代わりに表示する。
 * 新規アカウントを重複して作らせないため、既存アカウントとの統合以外の導線は用意しない。
 */
export function IntegrationSpecialAuditorNotice({ proceed }: Props) {
  const [consented, setConsented] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const disabled = useMemo(() => !consented || submitting, [consented, submitting]);

  const handleSubmit = useCallback(async () => {
    if (disabled) {
      return;
    }
    setSubmitting(true);
    await proceed();
    setSubmitting(false);
  }, [disabled, proceed]);

  return (
    <Card
      className={css({
        width: '343px',
        backgroundColor: '{colors.background.white}',
        padding: '{spacing.40} {spacing.20}',
        sm: { width: '400px', padding: '{spacing.40}' },
      })}
    >
      <div className={flex({ flexDirection: 'column', gap: '{spacing.16}' })}>
        <h1
          className={css({
            textStyle: 'headding.l',
            textAlign: 'center',
            color: '{colors.text.main}',
          })}
        >
          特別聴講生のアカウントを検出しました
        </h1>
        <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}' })}>
          新しいメールアドレスは追加できません。検出したアカウントでログインし、現在ご利用中のアカウントと統合してください。
        </p>
        <IntegrationConsent message={INTEGRATION_IRREVERSIBLE_MESSAGE} checked={consented} onChange={setConsented} />
      </div>
      <Button
        color="primary"
        size="l"
        stretch="container"
        disabled={disabled}
        onClick={handleSubmit}
        className={css({ marginTop: '{spacing.24}' })}
      >
        ログインへ進む
      </Button>
    </Card>
  );
}
